import { createFileRoute, useRouter } from "@tanstack/react-router";
import { HomeNav } from "@/components/home-nav";
import { useServerFn } from "@tanstack/react-start";

import { CopyLinkButton } from "@/components/copy-link";
import { GuestFilmPlayer } from "@/components/guest-film-player";
import { getGuestFilms, lockGuestSession } from "@/lib/guest.functions";

export const Route = createFileRoute("/guest-session/")({
  loader: () => getGuestFilms(),
  head: () => ({
    meta: [
      { title: "Guest Session — Full Films | Luiza Jesus do Prado" },
      { name: "description", content: "Private screening room for invited guests." },
      { property: "og:title", content: "Guest Session — Luiza Jesus do Prado" },
      { property: "og:description", content: "Private screening room for invited guests." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: GuestSession,
});

function GuestSession() {
  const { films } = Route.useLoaderData();
  const router = useRouter();
  const lock = useServerFn(lockGuestSession);

  async function leave() {
    await lock();
    await router.navigate({ to: "/guest-session/login" });
  }

  return (
    <>
    <HomeNav />
    <main id="main-content" className="min-h-svh bg-ink px-6 pb-32 pt-28 text-bone md:px-12">
      <div className="mx-auto max-w-[1600px]">
        <div className="flex items-center justify-end font-mono text-[10px] uppercase tracking-[0.3em] text-bone/65">
          <button type="button" onClick={leave} className="hover:text-bone">Leave</button>
        </div>
        <h1 className="mt-12 font-display text-[clamp(3rem,9vw,7rem)] font-light leading-[0.9] tracking-tight">
          Guest Session
        </h1>
        <p className="mt-6 max-w-xl text-sm leading-relaxed text-bone/65">
          Full-length performance films. Please do not share this access.
        </p>

        <div className="mt-20 grid gap-x-8 gap-y-16 md:grid-cols-2">
          {films.map((f) => (
            <figure key={`${f.provider}-${f.id}`} id={`film-${f.id}`} className="scroll-mt-24">
<GuestFilmPlayer film={f} />
              <figcaption className="mt-4 flex items-baseline justify-between gap-4 border-t border-bone/12 pt-3">
                <span className="font-display text-2xl font-light">{f.title}</span>
                <span className="flex items-center gap-3">
                  <span className="font-mono text-[9px] uppercase tracking-[0.28em] text-bone/65">{f.project}</span>
                  <CopyLinkButton url={`https://www.luizajesusdoprado.com/guest-session/film/${f.id}?t=${f.token}`} className="px-2 py-1" />
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </main>
    </>
  );
}
